import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable(
  //{providedIn: 'root'}
)
export class InterceptorService implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        // Si la respuesta es 401 o 403, limpiar el localStorage y redirigir al login
        if (error.status === 401 || error.status === 403) {
          localStorage.clear();  // Limpia el localStorage y cierra sesión
          this.router.navigate(['/login']);  // Redirige al login
        }
        return throwError(error);
      })
    );
  }

}
